import React from 'react';
import Layout from '../components/Layout';

const PrivacyPage = () => (
	<Layout>
		<div className="container light vertPadding">
			<h2>Privacy Policy</h2>
			<p className="body-text">
				<strong>1. &nbsp;</strong>
				<strong>Purpose and Scope of this Privacy Policy.</strong>
			</p>
			<p className="body-text">
				<strong>(a) &nbsp;</strong>This privacy policy describes how Hearst Communications, Inc. and its
				Affiliates (collectively, "<strong>Hearst</strong>") treat the Personally Identifiable Information that
				is collected about you when you visit the web sites, mobile-optimized versions of the web sites, and
				digital applications to which this policy is linked (collectively, "
				<strong>Covered Sites</strong>"). For the purposes of this policy, an entity controlling, controlled by,
				or under common control with another entity shall be deemed to be an "Affiliate", where control means
				ownership of 15% or more of the voting stock or other ownership interests. For the purposes of this
				policy, "
				<strong>Personally Identifiable Information</strong>
				" is information that we can use to identify or contact you as an individual, and includes your name,
				email address, address, telephone number and any other information that we associate with any of the
				foregoing. By submitting Personally Identifiable Information through any of our Covered Sites, you agree
				to the terms of this privacy policy and you expressly consent to the collection, use and disclosure of
				your Personally Identifiable Information in accordance with this privacy policy.
			</p>
			<p className="body-text">
				<strong>(b) &nbsp;</strong>This privacy policy does not apply to information collected about you by
				anyone except Hearst and only applies to the Covered Sites (defined above). This privacy policy does not
				apply to Hearst websites which are&nbsp;
				<u data-redactor-tag="u" data-verified="redactor">
					not
				</u>
				&nbsp;linked to this policy and does not apply to non-Hearst websites, including those linked to or
				advertised on a Covered Site.&nbsp; Any information you provide when you visit websites other than those
				covered by this policy will be subject to the privacy policies posted on those sites.
			</p>
			<p className="body-text">
				<strong>(c) &nbsp;</strong>We may offer our Magazines through certain third party websites via a
				subscription page on such third party websites that is linked to this policy. For the avoidance of
				doubt, such subscription page is a "Covered Site" and this policy applies to information collected
				through the subscription page, but does not apply to information collected through the third party
				website.
			</p>
			<p className="body-text">
				<strong data redactor-tag="strong">
					(d) &nbsp;
				</strong>
				Except as specified herein, this policy also does not apply to information you may provide to us
				offline; however please do be aware that if you subscribe offline to one of the magazines published by
				Hearst ("
				<strong>Magazines</strong>"), from time to time we make your postal addresses available to companies for
				marketing purposes.
			</p>
			<p className="body-text">
				<strong>(e) &nbsp;</strong>Certain features of the Covered Sites may be subject to additional or
				different privacy provisions, which will be posted on the Covered Site in connection with such features.
				All such additional or different privacy provisions are incorporated by reference into this privacy
				policy.
			</p>
			<p className="body-text">
				<strong>2. &nbsp;</strong>
				<strong>Collection of Information</strong>
			</p>
			<p className="body-text">
				<strong>(a) &nbsp;</strong>
				<strong>Information You Provide.</strong>
				&nbsp;Hearst generally collects Personally Identifiable Information that you voluntarily provide.&nbsp;
				For instance, when you enter a sweepstakes or contest, complete a survey, participate in a reader panel,
				register for those portions of our Covered Sites that may require registration, make a purchase,
				participate in our social networking features, request back issues of our Magazines, subscribe to our
				Magazines, subscribe to receive newsletters, promotional correspondence, or other electronic services,
				or send us an email or feedback, you may be asked to provide information such as your e-mail address,
				name, phone number, shipping address, and billing information, and we will collect such information as
				well as any other content you provide us in engaging in any of the above activities. Information such as
				your age, gender, hobbies or interests may also be requested. If you elect to post material to any
				blogs, forums, participate in our social networking features or other community boards that may be
				offered on our Covered Sites, then such materials will be collected and may be publicly available for
				others to view.
			</p>
			<p className="body-text">
				<strong>(b) &nbsp;</strong>
				<strong>Cookies and other technologies.</strong>
			</p>
			<p className="body-text">
				(i) &nbsp;Hearst (or third party service providers on our behalf) may set and access cookies and similar
				technologies on your computer. A cookie is a small amount of data (often including a unique identifier),
				that is sent to your browser from a web site's computers and stored on your computer's hard drive. Some
				of our cookies may be local shared objects, also known as Flash cookies. Cookies may be session cookies
				(which expire once you close your web browser) and persistent cookies (which stay on your computer until
				you delete them).&nbsp; Hearst uses cookies to understand site usage and to improve the content and
				offerings on our Covered Sites and in other media. We may use cookies to control the display of ads, to
				track usage patterns on the sites, to deliver editorial content, to record requests for subscriptions
				and to personalize information. Our cookies may contain Personally Identifiable Information and such
				cookies may be shared with others to the same extent indicated in Section 4. Hearst (or third party
				service providers on our behalf) may also use cookies to collect aggregate information about web site
				users on an anonymous basis ("Anonymous Information").&nbsp; We may share aggregate demographic and
				usage information with our prospective and actual business partners, advertisers and other third parties
				for any business purpose.
			</p>
			<p className="body-text">
				(ii) &nbsp;Some of our third party partners (including advertisers and marketing services companies) may
				set and access cookies and similar technologies on your computer as well, or we may do so on their
				behalf. We do not have control over how these third parties use such cookies and similar technologies or
				the information derived therefrom.
			</p>
			<p className="body-text">
				(iii) &nbsp;If you don't want cookies, most Web browsers include an option that allows you to not accept
				them. However, if you set your browser to refuse cookies, some portions of our Covered Sites may not
				function efficiently.&nbsp; Flash cookies may regenerate HTTP cookies that you have affirmatively
				deleted.&nbsp; Deleting, rejecting, disabling or turning off HTTP cookies as described above will not
				remove flash cookies.&nbsp; We use flash cookies as an alternative method to HTTP cookies for storing
				information about your web browsing history across unaffiliated domains, unrelated to the delivery of
				content through the Flash Player or the performance of the Flash Player in delivering such content. You
				can manage and delete flash cookies by visiting&nbsp;
				<a
					rel="noreferrer"
					className="body-link"
					href="http://kb2.adobe.com/cps/526/52697ee8.html"
					target="_blank"
				>
					http://kb2.adobe.com/cps/526/52697ee8.html
				</a>
				.
			</p>
			<p className="body-text">
				(iv) &nbsp;Some of our emails may contain tags that allow us and our advertisers and other partners to
				determine the types of content that may be of interest to you. Those tags&nbsp; may contain Personally
				Identifiable Information and may be shared with others to the same extent indicated in Section 4.&nbsp;
				Those tags may not be deleted but you can opt out of receiving the emails as explained in section 5.
			</p>
			<p className="body-text">
				<strong>(c) &nbsp;</strong>
				<strong>Gifs.&nbsp;</strong>&nbsp;We may use "
				<strong>clear GIFs</strong>" (aka "
				<strong>web beacons</strong>" or "
				<strong>pixel tags</strong>") or similar technologies, in the sites and in our communications with you
				to enable us to know whether you have visited a web page or received a message. A clear GIF is typically
				a one-pixel, transparent image (although it can be a visible image as well), located on a web page or in
				an e-mail or other type of message, which is retrieved from a remote site on the Internet enabling the
				verification of an individual's viewing or receipt of a web page or message. A clear gif may enable us
				to relate your viewing or receipt of a web page or message to other information about you, including
				your Personally Identifiable Information.
			</p>
			<p className="body-text">
				<strong>(d) &nbsp;</strong>
				<strong>IP Address.</strong>&nbsp; Your Internet Protocol ("<strong>IP</strong>") address is usually
				associated with the place from which you enter the Internet, like your Internet Service Provider, your
				company or your university. Our server may also record the referring page that linked you to us (e.g.,
				another Web site or a search engine); the pages you visit on our Covered Sites, the web sites you visit
				after this web site; the ads you see; the ads you click on; other information about the type of web
				browser, computer, platform, related software and settings you are using; any search terms you have
				entered on this web site or a referral site; and other web usage activity and data logged by our web
				servers.&nbsp; We may use your IP address to help diagnose problems with our servers, gather broad
				demographic information, and administer our Covered Sites. We may also link this information with your
				Personally Identifiable Information when we feel that it is necessary to enforce compliance with our
				rules and policies or terms of service or to protect our Covered Sites, customers or others.
			</p>
			<p className="body-text">
				<strong>(e) &nbsp;</strong>
				<strong>Location Information.&nbsp;</strong>We may, and may enable our advertisers to, collect your
				location via certain services we provide through digital applications, wireless access protocol services
				("<strong>WAP Services</strong>") or mobile phone service ("
				<strong>Mobile Services</strong>"). We, or the service provider, will inform you of such collection at
				the time you use the service.&nbsp;
				<strong>
					By using such service, you hereby consent to our collection, use and disclosure of your location
					information as described.
				</strong>
			</p>
			<p className="body-text">
				<strong>(f) &nbsp;</strong>
				<strong>Third Parties.&nbsp;</strong>We may receive information from third parties, including
				demographic information from your mobile carrier, and information from third parties that solicit
				subscriptions to our magazines. Those third parties have privacy policies that differ from this Privacy
				Policy.
			</p>
			<p className="body-text">
				<strong>(g) &nbsp;</strong>
				<strong>Tracking Requests.&nbsp;</strong>Hearst does not act on Do Not Track requests from your
				browser.&nbsp; For more information&nbsp;
				<a
					className="body-link"
					href="http://www.harpersbazaar.com/about/privacy-policy#tracking_requests"
					target="_blank"
				>
					click here
				</a>
				.
			</p>
			<p className="body-text">
				<a rel="noreferrer" className="body-link" name="tracking_requests">
					_
				</a>
			</p>
			<p className="body-text">
				<strong>(h)</strong>
				<strong>Effect of Tracking Requests</strong>. Hearst does not act on Do Not Track requests from your
				browser because, this way, we are able to personalize your experience on our sites and tailor content to
				your interests.
			</p>
			<p className="body-text">
				<strong>3. &nbsp;</strong>
				<strong>Use of Information.&nbsp;</strong>
			</p>
			<p className="body-text">
				<strong>(a) &nbsp;</strong>Hearst uses information we collect from you in part to provide you with the
				service you have requested. If you subscribe to any of our Magazines, we may also use your e-mail
				address to send you a confirmation notice and your mailing address to send you your Magazine.&nbsp;
				Similarly, if you enter online sweepstakes, we will also use this information to notify you if you are a
				winner.&nbsp; We also use your information to identify you as a user, improve our Covered Sites and
				services, send you administrative notifications, and respond to your inquiries. We might also send out
				e-mails to users and sweepstakes/contest entrants to announce special offers, services and announcements
				from our Covered Sites, our partners and/or our advertisers. We also use information in connection with
				advertising and to serve other content, as described in section 4(d) below.
			</p>
			<p className="body-text">
				<strong>(b)</strong>&nbsp;We may combine and use any and all information we collect on you either online
				or otherwise, including from third parties, for marketing purposes.
			</p>
			<p className="body-text">
				<strong>(c)</strong>&nbsp;When you subscribe to a digital edition of one of our magazines, you will
				automatically be assigned a user name (which is your email address) and password. Your user name and
				password will be retained and recognized in the event you thereafter subscribe to a digital edition of
				another one of our magazines.
			</p>
			<p className="body-text">
				<strong>(d) &nbsp;</strong>In addition, we may use information you provide us through emails, Q&amp;A,
				blogs, forums, in response to polls, or through any other user generated submission for editorial
				purposes, and may use your name and any stories you provide us in articles published online and in our
				Magazines.&nbsp; If you provide us with personal anecdotes, they may be attributed to you. &nbsp;Hearst
				can edit, rewrite, use, and reuse the content, including your name, likeness, photograph, and
				biographical information you provide, with or without attribution, including publication in the
				Magazines, and in trade media, and advertising.
			</p>
			<p className="body-text">
				<strong>(e) &nbsp;</strong>We may create Anonymous Information from Personally Identifiable Information
				by excluding information (such as your name) that make the data personally identifiable to you.&nbsp; We
				use this Anonymous Information for any purpose and disclose Anonymous Information to third parties in
				our sole discretion.
			</p>
			<p className="body-text">
				<strong>4. &nbsp;</strong>
				<strong>Disclosure of Your Information</strong>
			</p>
			<p className="body-text">
				<strong>(a) &nbsp;</strong>In addition to the other disclosures described in this policy, Hearst may
				(and you authorize us to) share or disclose Personally Identifiable Information about you to other
				companies or individuals in the following situations:
			</p>
			<p className="body-text">
				<strong>(i) &nbsp;</strong>We utilize third party service providers to provide products, services or
				functions on our behalf (such as sending emails or processing credit cards or fulfilling subscriptions),
				and ask these service providers to agree to maintain the confidentiality of your Personally Identifiable
				Information and not to use your Personally Identifiable Information for any reason except to carry out
				the purpose(s) for which we hired them ("
				<strong>Service Provider Exception</strong>").
			</p>
			<p className="body-text">
				<strong>(ii) &nbsp;</strong>You have entered a contest or sweepstakes sponsored by a third party, in
				which case the information you provide via the contest or sweepstakes may be shared by us with that
				third party for their use in their discretion, including direct marketing. Some of our contests and
				sweepstakes will ask you at the time of entry whether you would like to have your personal information
				shared with the sponsor, in which case we will honor your selection. Other contests will not give you
				that option and in that event, if you do not want your information to be shared, you should not enter
				the contest.&nbsp; The privacy policies of such third party companies apply to their use and disclosure
				of your information that we collect and disclose to such third party companies.
			</p>
			<p className="body-text">
				<strong>(iii) &nbsp;</strong>The entity to whom the information is disclosed is an Affiliate of Hearst.
			</p>
			<p className="body-text">
				<strong>(iv) &nbsp;</strong>In accordance with your indicated preferences (e.g., you indicated you
				wanted to receive promotional materials directly from a third party partner).
			</p>
			<p className="body-text">
				<strong>(v) &nbsp;</strong>The entity is a third party who wants to promote goods and services we think
				would be of interest to you.
			</p>
			<p className="body-text">
				<strong>(vi) &nbsp;</strong>You have furnished us Personally Identifiable Information with the intent
				that it be forwarded to a third party for use in connection with a specified service you are electing to
				participate in (examples include, without limitation, e-commerce partners, services to help old friends
				locate you online, etc.).
			</p>
			<p className="body-text">
				<strong>(vii) &nbsp;</strong>We need to protect our legal rights (for example, if we are trying to
				collect money you owe us); we must comply with applicable laws, regulations, or legal or regulatory
				process, or comply with subpoenas or warrants served on us, or in connection with a legal investigation;
				or we have reason to believe that someone may be causing injury to someone or interfering with our
				rights or the rights of our users, or general public, or using our services in violation of a legal or
				personal right, including our Terms of Use (collectively, the "
				<strong>Legal Exceptions</strong>").
			</p>
			<p className="body-text">
				<strong>(viii) &nbsp;</strong>In connection with a sale, merger, transfer, exchange, or other
				disposition (whether of assets, stock, or otherwise, including via bankruptcy) of all or a portion of
				the business conducted by the Covered Site to which this policy applies, in which case the company will
				possess the Personally Identifiable Information collected by us and will assume the rights and
				obligations regarding your Personally Identifiable Information as described in this privacy policy ("
				<strong>Acquisition Exception</strong>").
			</p>
			<p className="body-text">
				<strong>(b) &nbsp;</strong>
				<strong>Social Networks.&nbsp;</strong>&nbsp;If you use your login credentials from a social networking
				site (e.g., Facebook or Twitter) ("<strong>SNS</strong>") on a Covered Site, we may receive information
				from such SNS in accordance with the terms and conditions (e.g., terms of use and privacy policy) of the
				SNS ("
				<strong>SNS Terms</strong>"). If you elect to share your information with these SNS, we will share
				information with them in accordance with your election.&nbsp; The SNS Terms of these SNS will apply to
				the information we disclose to them.
			</p>
			<p className="body-text">
				<strong>(c) &nbsp;</strong>
				<strong>Third Party Partners.</strong>&nbsp;Some of our Covered Sites may from time to time partner with
				a retailer or other third party to offer online shopping opportunities, games, services, subscriptions
				and other applications on a co-branded or cross-promotional basis. Those transactions may take place on
				a Covered Site, or the site of the third party. In either case, Personally Identifiable Information you
				provide in connection with the transaction may be collected directly by, or shared by Hearst with, the
				third party, as well as with any participating sponsors or advertisers of such opportunities and
				features. Some of our Covered Sites may offer you the ability to access a third-party site with whom we
				have a relationship to access both sites through a co-branded registration or password; in that event,
				your applicable registration information may be collected directly by, or shared by Hearst with, the
				third-party partner.&nbsp; We will notify you at the applicable point of sign up if any such co-branded
				registration or password practices will be in effect.&nbsp; These third parties will use your
				information in accordance with their own privacy policy.
			</p>
			<p className="body-text">
				<strong>(d) &nbsp;</strong>
				<strong>Delivery of Advertising and Other Content.</strong>
			</p>
			<p className="body-text">
				<strong>(i) &nbsp;</strong>&nbsp;In addition to ads and content that we serve you directly, we use
				third-party advertising companies and&nbsp; marketing services companies to serve ads and other content
				when you visit our Covered Sites and elsewhere on the internet and in other media.&nbsp; Both we and
				these companies may use information about your visits to this Covered Site and elsewhere to serve ads
				and other content to you. In the course of doing so, a unique third-party cookie may be placed or
				recognized on your browser by such companies.&nbsp; In addition, we and these companies may use Web
				beacons to help manage our online advertising and content.&nbsp; These Web beacons enable us and
				the&nbsp; third-party companies to recognize a browser's cookie when a browser visits this site and to
				learn which banner ads bring users to our website and to serve you ads that you may find of interest
				elsewhere on the internet and in other media.&nbsp; Both Hearst and these companies may use
				information&nbsp; obtained from your visits to the Covered Sites (including your status as a customer of
				Hearst), other websites, and information received from you offline in order to provide advertisements
				about goods and services and other content of interest to you across the internet and in other
				media.&nbsp; If you would like more information about this practice and to know your choices about not
				having this information used in this manner by our third party advertising companies please visit&nbsp;
				<a
					rel="noreferrer"
					className="body-link"
					href="http://www.networkadvertising.org/optout_nonppii.asp"
					target="_blank"
				>
					http://www.networkadvertising.org/optout_nonppii.asp
				</a>
				. The collection of information via certain ads served to users in Canada may be managed by visiting
				youradchoices.ca, and via certain ads served to users in Europe may be managed at youronlinechoices.com.
				You may also visit alc-opt-out.com&nbsp;and&nbsp;
				<a
					rel="noreferrer"
					className="body-link"
					href="https://portal.solvemedia.com/portal/public/opt-out"
					target="_blank"
				>
					https://portal.solvemedia.com/portal/public/opt-out
				</a>
				&nbsp;to find out how our marketing services companies operate.
			</p>
			<p className="body-text">
				<strong>(ii) &nbsp;</strong>In addition, we may provide Personally Identifiable Information and
				Anonymous Information to marketing services companies.&nbsp; This may include information we received
				from you offline or online. These companies may combine information we provide (including Personally
				Identifiable&nbsp; Information and Anonymous Information) with personal and anonymous information they
				may have about you, using cookies they place or that we place on their behalf, as described in Section
				2(b).&nbsp; We require these companies to delete the Personally Identifiable Information we provide
				them.&nbsp; These companies may use the resulting non-personal information and such cookies for their
				own marketing purposes, and they may provide the same to their customers for their customer's marketing
				purposes.&nbsp; If you would like to know your choices about not having this information used by such
				companies, please visit: alc-opt-out.com&nbsp;and&nbsp;&nbsp;
				<a
					rel="noreferrer"
					className="body-link"
					href="https://portal.solvemedia.com/portal/public/opt-out"
					target="_blank"
				>
					https://portal.solvemedia.com/portal/public/opt-out
				</a>
				.
			</p>
			<p className="body-text">
				<strong>(e) Video Services.&nbsp;</strong>We may offer the right for you to access certain video content
				as a paid subscription service or via a registration process for specific content ("Video Services"). As
				a condition of becoming a subscriber or a registrant, you must grant your consent to allow us to share
				information about the content you have viewed to third parties in order to provide you with the service,
				for our and others' marketing purposes and to help you inform others about your experiences on social
				media services such as Facebook and Twitter.&nbsp; If you no longer wish us to share information about
				what you have watched on our service, you can cancel your subscription at any time (in the case of
				subscription services) or ask that your information not be shared (in the case of registration
				services). A list of those&nbsp; Video Services, together with information on how to contact customer
				service about your account, will appear here. Current Video Services are: None. The provisions of this
				section 4(e) apply only to videos that are accessible by subscription or registration, and not to other
				videos that may be viewed on our Covered Sites.
			</p>
			<p className="body-text">
				<strong>5. &nbsp;</strong>
				<strong>Right to Opt-out</strong>
			</p>
			<p className="body-text">
				<strong>(a) &nbsp;</strong>
				<strong>
					<a rel="noreferrer" className="body-link" name="california">
						California &amp; Canadian Users: Your California Privacy Rights.
					</a>
				</strong>
				&nbsp;California's "Shine the Light" law, Civil Code section 1798.83, requires certain businesses to
				respond to requests from California customers asking about the businesses' practices related to
				disclosing personal information to third parties for the third parties' direct marketing purposes.&nbsp;
				Alternatively, such businesses may have in place a policy not to disclose personal information of
				customers to third parties for the third parties' direct marketing purposes if the customer has
				exercised an option to opt-out of such information sharing.&nbsp; We have such a policy in place.&nbsp;
				Sections 4(d) and &nbsp;5(d) explain our practices and how you can opt-out of having your information
				shared with third parties for the third parties' direct or indirect marketing purposes, in accordance
				with such laws.&nbsp; In addition to reviewing Sections 4(d) and 5(d), if you wish to find out about any
				rights you may have under California Civil Code section 1798.83, you may notify us in writing at Mail
				Preference Service, P.O. Box 6000, Harlan, Iowa 51593 or contacting us at&nbsp;
				<a rel="noreferrer" className="body-link" href="mailto:customercare@hearstmags.com" target="_blank">
					customercare@hearstmags.com
				</a>
				. In the case of marketing via Video Services, please refer to the customer service contact set forth at
				section 4(e) above. Canadian residents also have certain rights to know how their information may be
				shared with third parties who engage in direct marketing activities.&nbsp; Again, Sections 4(d) and 5(d)
				explain our practices and how you can opt-out of having your information shared for such purposes, in
				accordance with such laws.For the avoidance of doubt, these opt-out options are available for all users
				and are not limited to Californian and Canadian users.
			</p>
			<p className="body-text">
				<strong>(b) &nbsp;</strong>
				<strong>Mobile Opt-out.</strong>&nbsp;We may provide you messages, including marketing, via your
				wireless email address or by short message service ("
				<strong>SMS Service</strong>"), WAP or Mobile Services as described in Section 6.&nbsp; You may opt-out
				of these messages from us by replying "STOP" or following the instructions provided in the message.
			</p>
			<p className="body-text">
				<strong>(c) &nbsp;</strong>
				<strong>Marketing provided by Hearst.</strong>
				&nbsp; From time to time we may send you promotional materials on behalf of Hearst and/or third parties.
				If you want us to stop sending you promotional materials to your email, you may follow the unsubscribe
				instructions in the email or manage your preferences at&nbsp;
				<a rel="noreferrer" className="body-link" href="http://preferences.hearstmags.com" target="_blank">
					preferences.hearstmags.com
				</a>
				. If you want us to stop sending you promotional materials to your postal mailing address, you may
				notify us in writing by sending a notice to Mail Preference Service, P.O. Box 6000, Harlan, Iowa 51593
				or contacting us at&nbsp;
				<a rel="noreferrer" className="body-link" href="mailto:customercare@hearstmags.com" target="_blank">
					customercare@hearstmags.com
				</a>
				.&nbsp; Certain Covered Sites may include a customer service link at the bottom of such site.&nbsp; If
				so, you may also manage your email preferences through that link.
			</p>
			<p className="body-text">
				<strong>(d) &nbsp;</strong>
				<strong>Marketing provided by Third Parties.&nbsp;</strong>
				&nbsp;From time to time we may disclose your contact information to third parties to allow them to
				market their products or services to you or for other marketing purposes.&nbsp; This may be information
				we received from you offline and online.&nbsp; If you want us to stop further sharing your email contact
				information with third parties (if we have your email contact information), you may notify us at&nbsp;
				<a rel="noreferrer" className="body-link" href="http://preferences.hearstmags.com" target="_blank">
					preferences.hearstmags.com
				</a>
				. If you want us to stop further sharing your postal mailing contact information with third parties (if
				we have your postal address), you may notify us in writing by sending a notice to Mail Preference
				Service, P.O. Box 6000, Harlan, Iowa 51593 or contacting us at&nbsp;
				<a rel="noreferrer" className="body-link" href="mailto:customercare@hearstmags.com" target="_blank">
					customercare@hearstmags.com
				</a>
				. If you wish to opt out of having your information shared with marketing services companies, please see
				section 4(d) above. In the case of marketing via Video Services, please refer to the customer service
				contact set forth at section 4(e) above. &nbsp;In the case of information collected by our Third Party
				Partners, you should consult their own privacy policies to determine how your Personally Identifiable
				Information will be used, and&nbsp; follow the instructions provided to you by those Third Party
				Partners to unsubscribe from their messages and customize your preferences.
			</p>
			<p className="body-text">
				<strong>(e) &nbsp;</strong>
				<strong>Exceptions.&nbsp;</strong>;If you have opted-out as described above, and thereafter you elect to
				use a service or promotion that requires us to contact you or share your information with a third party
				(e.g., you enter into a contest or sweepstakes or use an ecommerce service after opting-out), then your
				previous opt-out preferences will not apply to such service.&nbsp; Despite your indicated preferences,
				we may send you service related communications, including notices about your subscription, and we may
				continue disclosing your information to third parties under the Service Provider Exception, Legal
				Exceptions, and Acquisition Exception described above.
			</p>
			<p className="body-text">
				<strong>(f) &nbsp;</strong>Device Settings.&nbsp; Our digital applications may provide you alerts and
				you can change your preferences regarding these alerts through your device settings.
			</p>
			<p className="body-text">
				<strong>6. &nbsp;</strong>
				<strong>Wireless Email Address, Short Message Services and&nbsp;</strong>
				<strong>WAP.;&nbsp;</strong>If the email address you provide to us is a wireless email address, you
				agree to receive messages at such address from Hearst or from third parties.&nbsp; Similarly, we may
				make available services through which you can receive messages on your phone or wireless device SMS
				Service or WAP Services.&nbsp; We may also make available content and versions of our Covered Sites
				available via WAP and Mobile Services. If you subscribe to one of our SMS, WAP or Mobile Services, you
				thereby agree to receive services and messages at the address you provide for such purposes.&nbsp; Such
				messages may come from Hearst, or from third parties.&nbsp; To use the wireless email address, SMS, WAP,
				or Mobile Service, you must reside in the United States.&nbsp; We may also obtain the date, time and
				content of your messages.&nbsp; We will use the information we obtain in connection with these services
				in accordance with this Privacy Policy. Your wireless carrier and other service providers may also
				collect data about your wireless device usage, and their practices are governed by their own
				policies.&nbsp;&nbsp;
				<strong>
					By providing us your wireless email address or by signing up for any SMS, WAP, or Mobile Service,
					you consent to receiving messages as described above.&nbsp; You understand that your wireless
					carrier's standard rates apply to these messages.&nbsp; You represent that you are the owner or
					authorized user of the wireless device on which messages will be received, and that you are
					authorized to approve the applicable charges.
				</strong>
			</p>
			<p className="body-text">
				<strong>7. &nbsp;</strong>
				<strong>Security of Your Personally Identifiable Information.&nbsp;&nbsp;</strong>
				We use a variety of industry-standard security technologies and procedures to help protect your
				Personally Identifiable Information from unauthorized access, use, or disclosure.&nbsp; We also require
				you to enter a password to access your registration information. Please do not disclose your
				registration password to unauthorized people.&nbsp; No method of transmission over the Internet, or
				method of electronic storage, is 100% secure, however. Therefore, while Hearst uses reasonable efforts
				to protect your Personally Identifiable Information, Hearst cannot guarantee its absolute security.
			</p>
			<p className="body-text">
				<strong>8. &nbsp;</strong>
				<strong>Kids And Parents.&nbsp;&nbsp;</strong>The Covered Sites are not intended for use by children,
				especially those under age 13.&nbsp; If your children disclose information about themselves in our
				public discussion areas, they may get unsolicited messages from other parties. Accordingly, you should
				tell them not to do so. There are also commercially available tools to help you limits your children's
				exposure to material online.&nbsp;
				<strong>Minors' Right to Request Deletion of User-Posted Comments:</strong>
				&nbsp;If you are a California resident and registered user on Seventeen.com &nbsp;and posted comments on
				that site when you were under 18 years old, you may request deletion of those comments by contacting us
				at&nbsp;
				<u data-redactor-tag="u" data-verified="redactor">
					<a rel="noreferrer" className="body-link" href="mailto:webfeedback@seventeen.com" target="_blank">
						webfeedback@seventeen.com
					</a>
				</u>
				. &nbsp;and indicate in the subject line "California take-down request". You must provide us with the
				live url where the content resides, a copy of the content (cut and pasted into your email), the date of
				publication and, if applicable, the user name associated with it. We will act as promptly as possible to
				remove the posting (except in certain circumstances mandated by law). Note that our deletion does not
				ensure complete or comprehensive removal of your content from the internet and comments that may have
				been posted by others &nbsp;about you or your posting will remain accessible online.
			</p>
			<p className="body-text">
				<strong>9. &nbsp;</strong>
				<strong>Non-U.S. Users.&nbsp;&nbsp;</strong>If you are located outside of the United States, please note
				that the information you provide to us will be transferred to and processed in the United States, where
				laws regarding processing of Personally Identifiable Information may be less stringent than the laws in
				your country. By using this Covered Site, you consent to this transfer and processing. You also consent
				to the adjudication of any disputes arising in connection with this Covered Site in the federal and
				state courts of, and in accordance with the laws of, the state of New York.
			</p>
			<p className="body-text">
				<strong>10. &nbsp;</strong>
				<strong>Dispute Resolution.&nbsp;</strong>PLEASE READ THIS CAREFULLY.&nbsp; IT AFFECTS YOUR RIGHTS.
			</p>
			<p className="body-text">
				<strong>(i) &nbsp;</strong>Except for either party's claims of infringement or misappropriation of the
				other party's patent, copyright, trademark, or trade secret, any and all disputes between you and Hearst
				arising under or related in any way to this Agreement, must be resolved through binding arbitration as
				described in this section.&nbsp; This agreement to arbitrate is intended to be interpreted
				broadly.&nbsp; It includes, but is not limited to, all claims and disputes relating to your use of any
				of the Covered Sites.
			</p>
			<p className="body-text">
				<strong>(ii) &nbsp;</strong>YOU AGREE THAT BY ENTERING INTO THIS AGREEMENT, YOU AND HEARST ARE EACH
				WAIVING THE RIGHT TO TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION.&nbsp; YOU AND HEARST AGREE THAT
				EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF
				OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.&nbsp; ANY ARBITRATION WILL TAKE
				PLACE ON AN INDIVIDUAL BASIS; CLASS ARBITRATIONS AND CLASS ACTIONS ARE NOT PERMITTED.
			</p>
			<p className="body-text">
				<strong>(iii) &nbsp;</strong>The arbitration will be governed by the Commercial Arbitration Rules and
				the Supplementary Procedures for Consumer Related Disputes of the American Arbitration Association ("<strong>AAA</strong>"),
				as modified by this section.&nbsp; For any claim where the total amount of the award sought is $10,000
				or less, the AAA, you and Hearst must abide by the following rules:&nbsp; (a) the arbitration shall be
				conducted solely based on written submissions; and (b) the arbitration shall not involve any personal
				appearance by the parties or witnesses unless otherwise mutually agreed by the parties.&nbsp; If the
				claim exceeds $10,000, the right to a hearing will be determined by the AAA rules, and the hearing (if
				any) must take place in your choice of the following locations: San Francisco, CA, Denver, CO, or New
				York, NY. The arbitrator's ruling is binding and may be entered as a judgment in any court of competent
				jurisdiction.&nbsp; In the event this agreement to arbitrate is held unenforceable by a court, then the
				disputes that would otherwise have been arbitrated shall be exclusively brought in the state or federal
				courts located in New York City, New York. Claims of infringement or misappropriation of the other
				party's patent, copyright, trademark, or trade secret shall be exclusively brought in the state and
				federal courts located in New York City, New York.
			</p>
			<p className="body-text">
				<strong>(iv) &nbsp;</strong>This Agreement shall be governed by and construed solely and exclusively in
				accordance with the laws of the State of New York, USA without giving effect to any law that would
				result in the application of the law of another jurisdiction.
			</p>
			<p className="body-text">
				<strong>11. &nbsp;</strong>
				<strong>Changes to This Privacy Policy.</strong>
				&nbsp;This privacy policy is subject to occasional revision, and if we make any material changes in the
				way we use your Personally Identifiable Information, we will prominently post notice of the changes on
				our Covered Sites. Any changes to this privacy policy will be effective upon thirty (30) calendar days
				following our posting of notice of the changes on our Covered Sites.&nbsp; These changes will be
				effective immediately for new users of our Covered Sites. Continued use of our Covered Sites, following
				notice of such changes shall indicate your acknowledgement of such changes and agreement to be bound by
				the terms and conditions of such changes.
			</p>
			<p className="body-text">Last revised on April 1, 2016</p>
		</div>;
	</Layout>
);

export default PrivacyPage;
